import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type Props = {
  title: string;
  hasErrors: boolean;
  expanded: boolean;
  onChange: (expanded: boolean) => void;
  titleDefaultColor?: string;
}

const ValidatedAccordionItem = ({
  title,
  hasErrors,
  expanded,
  onChange,
  titleDefaultColor = "#495057",
  children,
  }:
    React.PropsWithChildren<Props>) => {
  const showErrorStyle = hasErrors && !expanded;
return (
  <Accordion
    expanded={expanded}
    onChange={(_, isExp:any) => onChange(isExp)}
    disableGutters
    square
    sx={{
      border: 1,
      borderColor: showErrorStyle ? "error.main" : "divider",
      backgroundColor: showErrorStyle ? "error.main/8" : "background.paper",
      "&before": {display: "none"},
      transition: (t) =>
        t.transitions.create(["border-color", "background-color"],{
          duration: t.transitions.duration.short,
        }),
    }}

  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
    >
      <Typography
        component="legend"
        sx={{
          color: showErrorStyle ? "error.main" : titleDefaultColor,
        }}>
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      {children}
    </AccordionDetails>
  </Accordion>
)
};


export default ValidatedAccordionItem;